import styled from "styled-components";

export const Container = styled.div`
  padding-top: 32px;
  padding-left: 32px;
  padding-right: 154px;
  display: flex;
`;
